module.exports = __webpack_public_path__ + "img/图1-6  学校制图作业中使用的简化标题栏.93d613e5.jpg";